<template>
  <div>
    <h2 class="bordered-box-header">Szczegóły wybranego kursu</h2>
    <b-container fluid class="bordered-box">
      <b-row class="justify-content-center" v-if="loading">
        <b-spinner big label="Loading..."></b-spinner>
      </b-row>
      <b-row v-else-if="course">
        <b-col cols="12">
          <h3>
            {{course.name}}
            <span
              class="text-lowercase font-italic"
            >({{course.languageProficiency | languageProficiency}})</span>
          </h3>
          <p>{{course.description}}</p>
        </b-col>
        <b-col cols="12">
          <button class="btn btn-primary edit-item" @click="showEditCourseModal">Edytuj</button>
          <button
            class="btn btn-secondary add-item"
            @click="showAssignSubjectTemplateModal"
          >Przypisz temat</button>
        </b-col>

        <b-col cols="12">
          <draggable
            v-model="course.subjects"
            @start="drag=true"
            @end="drag=false"
            @change="onOrderChanged"
          >
            <b-row
              v-for="item in course.subjects"
              :key="item.id"
              class="item active-item align-items-center"
              :class="{'selected-item': selectedSubject == item}"
              @click="selectedSubject = item"
              no-gutters
            >
              <b-col lg="9" cols="12">
                <span>{{item.id}} - {{item.title}}</span>
              </b-col>
              <b-col lg="3" cols="12" class="text-right">
                <button
                  class="btn btn-danger edit-item m-1"
                  @click.stop="removeSubjectModal(item.id)"
                >Usuń</button>
              </b-col>
            </b-row>
          </draggable>
        </b-col>
      </b-row>
    </b-container>

    <subjectDetails
      v-if="selectedSubject"
      :id="selectedSubject.id"
      :key="selectedSubject.id"
      @changed="onSubjectChanged"
    />
    <editCourseModal ref="editCourseModal" @save="onEditCourse" :course="course" />
    <assignSubjectTemplateModal ref="assignSubjectTemplateModal" @save="onAssignSubjectTemplate" />
  </div>
</template>
<script>
import { axios, eventBus } from "@/_infrastructure";
import draggable from "vuedraggable";
import editCourseModal from "./EditCourseModal";
import assignSubjectTemplateModal from "./AssignSubjectModal";
import subjectDetails from "../Subjects/Details";

export default {
  data() {
    return {
      loading: false,
      course: null,
      selectedSubject: null
    };
  },
  props: ["id"],
  components: {
    draggable,
    editCourseModal,
    assignSubjectTemplateModal,
    subjectDetails
  },
  mounted() {
    if (this.id) {
      this.refresh();
    }
  },
  methods: {
    refresh() {
      this.loading = true;

      axios
        .get("/templatecourses/details", {
          params: {
            id: this.id
          }
        })
        .then(response => {
          this.course = response.data;
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          this.loading = false;
        });
    },
    onOrderChanged() {
      let loader = this.$loading.show({
        container: this.$refs.mainContainer
      });

      var r = {
        courseId: this.id,
        items: this.course.subjects.map(e => e.id)
      };

      axios
        .post("/templatecourses/subjects/order", r)
        .then(() => {
          eventBus.$emit("notify-success", "Zapisano poprawnie.");
        })
        .catch(error => {
          eventBus.$emit("unhandled-error", error);
          this.refresh();
        })
        .then(() => {
          loader.hide();
        });
    },
    onSubjectChanged(data) {
      this.selectedSubject.title = data.title;
    },
    showEditCourseModal() {
      this.$refs.editCourseModal.show();
    },
    onEditCourse(r) {
      let loader = this.$loading.show({
        container: this.$refs.mainContainer
      });

      r.id = this.id;

      axios
        .put("/templatecourses", r)
        .then(response => {
          var result = response.data;

          this.course.name = result.name;
          this.course.description = result.description;
          this.course.languageProficiency = result.languageProficiency;

          eventBus.$emit("notify-success", "Zapisano poprawnie.");
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          loader.hide();
        });
    },
    showAssignSubjectTemplateModal() {
      this.$refs.assignSubjectTemplateModal.show();
    },
    onAssignSubjectTemplate(id) {
      if (this.course.subjects.filter(s => s.id == id).length) return;

      let loader = this.$loading.show({
        container: this.$refs.mainContainer
      });

      var postParams = {
        courseId: this.id,
        subjectId: id
      };

      axios
        .post("/templatecourses/subjects", postParams)
        .then(response => {
          eventBus.$emit("notify-success", "Zapisano poprawnie.");
          var result = response.data;
          this.course.subjects.push(result);
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          loader.hide();
        });
    },
    removeSubjectModal(id) {
      this.$bvModal
        .msgBoxConfirm(
          "Czy na pewno chcesz usunąć z wybranego kursu wskazany temat?"
        )
        .then(value => {
          if (value) {
            this.onDeleteSubject(id);
          }
        });
    },
    onDeleteSubject(id) {
      let loader = this.$loading.show({
        container: this.$refs.mainContainer
      });

      var postParams = {
        courseId: this.id,
        subjectId: id
      };

      axios
        .delete("/templatecourses/subjects", {params: postParams})
        .then(() => {
          eventBus.$emit("notify-success", "Temat usunięto poprawnie.");
          this.$emit("deleted");

          this.course.subjects = this.course.subjects.filter(s => s.id != id);
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          loader.hide();
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.word-item {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 1px;
  padding: 5px;
  margin-bottom: -1px;

  &:hover {
    background: rgba(0, 0, 0, 0.03);
  }
}
.item {
  border: 1px solid rgba(0, 0, 0, 0.125);
  background: rgba(0, 0, 0, 0.03);
  border-radius: 1px;
  padding: 5px;
  margin-bottom: -1px;
  cursor: pointer;
}
.active-item {
  cursor: move;
}
.selected-item {
  background: rgba(0, 255, 0, 0.125);
}
.add-item,
.edit-item,
.delete-item {
  margin: 0px 10px 10px 0px;
}

h2.bordered-box-header {
  margin-top: 20px;
  padding: 10px;
  margin-bottom: 0px;
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.bordered-box {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 10px;
}
</style>
